import { allAdminRoles } from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";

const notAllowedStatusForComment = [
  "Saved",
  "Rejected",
  "Connection Released",
  "Application Process Completed",
];

export const isCommentInputVisible = (status, roles, isCommented) => {
  if (isAuthorizedUser(roles, allAdminRoles)) {
    return !notAllowedStatusForComment.includes(status);
  }
  return !notAllowedStatusForComment.includes(status) && isCommented;
};
